var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.state.dataUsers.role=='super_user')?_c('UsersList',{attrs:{"title":_vm.title}}):(_vm.$store.state.dataUsers.role=='admin')?_c('AdminBuList',{attrs:{"title":_vm.title}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }